// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-58244431]{box-sizing:border-box}.button[data-v-58244431]{background:#1976d2;border:0;border-radius:100px;color:#fff;cursor:pointer;font-size:15px;height:48px;line-height:22px;width:200px}.answer[data-v-58244431],.button[data-v-58244431]{font-weight:700;text-align:center}.answer[data-v-58244431]{color:rgba(0,0,0,.87);display:block;font-size:24px;line-height:48px}@media(min-width:960px){.answer[data-v-58244431]{font-size:28px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
